import React, { useState } from 'react';
import logo from '../assets/logo.png';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from './LanguageSwitcher';
import { localeConfig } from '../i18n';

const Nav = () => {
  const { t, i18n } = useTranslation(['nav', 'brand']);
  const brandTrademark = t('brand.trademark', { ns: 'brand' });
  const [opened, setOpened] = useState(true);
  const currentLang = i18n.language;
  
  const buildPath = (slug = '') => {
    // Если это язык по умолчанию, не добавляем префикс
    if (currentLang === localeConfig.defaultLocale) {
      return slug ? `/${slug}` : '/';
    }
    
    // Для других языков добавляем префикс
    return slug ? `/${slug}/${currentLang}` : `/${currentLang}`;
  };
  
  const getSectionLink = (section) => `${buildPath()}#${section}`;

  return (
    <div className='w-100'>
      <div className='container'>
        <header className='flex jcsb aic h-10 py-5'>
          <h1 id='logo'>
            <a href={buildPath()} aria-label='Logotype'>
              <img src={logo} width={162} height={162} alt={brandTrademark} />
            </a>
          </h1>
          <div
            className={opened ? 'burger' : 'burger open'}
            onClick={() => setOpened(!opened)}
          >
            <span className='tt'></span>
            <span className='mm'></span>
            <span className='bb'></span>
          </div>
          <div className={opened ? 'menu active' : 'menu'}>
            <a
              href={getSectionLink('about')}
              className='mx-3 px-1'
              onClick={() => setOpened(!opened)}
            >
              {t('menu.about')}
            </a>
            <a
              href={getSectionLink('offer')}
              className='mx-3 px-1'
              onClick={() => setOpened(!opened)}
            >
              {t('menu.offer')}
            </a>
            <a
              href={getSectionLink('cta')}
              className='mx-3 px-1'
              onClick={() => setOpened(!opened)}
            >
              {t('menu.cta')}
            </a>
            <a
              href={getSectionLink('contact')}
              className='mx-3 px-1'
              onClick={() => setOpened(!opened)}
            >
              {t('menu.contact')}
            </a>
            <a
              href={getSectionLink('organization')}
              className='mx-3 px-1'
              onClick={() => setOpened(!opened)}
            >
              {t('menu.organization')}
            </a>
            <div className='mx-3 px-1 m-block'>
              <LanguageSwitcher />
            </div>
          </div>
          <LanguageSwitcher className='m-hide' />
        </header>
      </div>
    </div>
  );
};

export { Nav };
